import TR from 'utils/TR';
import AverageGlycemicIndexBox from 'components/details/AverageGlycemicIndexBox';
import CVBox from 'components/details/CVBox';
import GMIBox from 'components/details/GMIBox';
import TIRBox from 'components/details/TIRBox';
import T from 'utils/T';
import ex from 'utils/ex';
import AbnormalBloodGlocoseCountBox from 'components/details/AbnormalBloodGlocoseCountBox';
import KeyBloodGlocoseMBTIBox from 'components/details/KeyBloodGlocoseMBTIBox';
import Honeycomb from 'components/common/Honeycomb';
import Segment from 'components/common/Segment';
import DIRECTION_VERTICAL from 'constants/DIRECTION_VERTICAL';
import HBox from 'components/common/HBox';
import Dot from 'components/common/Dot';
import SummaryBox from './SummaryBox';
import VBar from './VBar';
import CHECK_COLORS from 'constants/CHECK_COLORS';

export default function GlocoseSummary(props) {
  const {
    data,
    ...rest
  } = props || {};
  const {
    avg_bld_sugr = 0,
    gmi = 0,
    tir = 0,
    cv = 0,
    high_bld_sugr_cnt = 0,
    low_bld_sugr_cnt = 0,
    week_days_bld_sugr_mbti = '',
    weekend_bld_sugr_mbti = '',
  } = data || {};
  return (
    <div {...ex('GlocoseSummary', rest)}>
      <Segment
        {...ex('Summary', {
          direction: DIRECTION_VERTICAL,
        })}
      >
        <HBox {...ex('SummaryTitle')} between>
          <div>
            {T('혈당통계')}
          </div>
          <HBox>
            <Dot {...{ color: '#0070FF' }}>
              <div>
                좋음
              </div>
            </Dot>
            <Dot {...{ color: '#FF7D5E' }}>
              <div>
                주의
              </div>
            </Dot>
          </HBox>
        </HBox>
        <HBox {...ex('SummaryItems')} between>
          <SummaryBox
            {...{
              caption: T('평균혈당'),
              value: avg_bld_sugr,
              unit: 'mg/dL',
              type: CHECK_COLORS('B', avg_bld_sugr),
            }}
          />
          <VBar />
          <SummaryBox
            {...{
              caption: T('GMI'),
              value: gmi,
              unit: '%',
              type: CHECK_COLORS('GMI', gmi),
            }}
          />
          <VBar />
          <SummaryBox
            {...{
              caption: T('TIR'),
              value: tir,
              unit: '%',
              type: CHECK_COLORS('TIR', tir),
            }}
          />
          <VBar />
          <SummaryBox
            {...{
              caption: T('CV'),
              value: cv,
              unit: '%',
              type: CHECK_COLORS('CV', cv),
            }}
          />
        </HBox>
      </Segment>

      <Segment
        {...ex('Summary', {
          direction: DIRECTION_VERTICAL,
        })}
      >
        <HBox {...ex('SummaryTitle')} between>
          <div>
            {T('이상혈당 발생')}
          </div>
        </HBox>
        <HBox {...ex('SummaryItems')} between>
          <SummaryBox
            {...{
              caption: T('전체'),
              value: high_bld_sugr_cnt + low_bld_sugr_cnt,
              unit: '건',
            }}
          />
          <HBox>
            <SummaryBox
              {...ex('Sub', {
                caption: T('고혈당'),
                value: high_bld_sugr_cnt,
                unit: '건',
              })}
            >
              <Dot {...{ color: '#FF995A' }} />
            </SummaryBox>
            <SummaryBox
              {...ex('Sub', {
                caption: T('저혈당'),
                value: low_bld_sugr_cnt,
                unit: '건',
              })}
            >
              <Dot {...{ color: '#5D3FC5' }} />
            </SummaryBox>
          </HBox>
        </HBox>
      </Segment>

      <Segment
        {...ex('Summary', {
          direction: DIRECTION_VERTICAL,
        })}
      >
        <HBox {...ex('SummaryTitle')} between>
          <div>
            {T('혈당패턴')}
          </div>
        </HBox>
        <HBox {...ex('SummaryItems')} between>
          <SummaryBox
            {...{
              caption: T('주중'),
              value: week_days_bld_sugr_mbti,
            }}
          />
          <VBar />
          <SummaryBox
            {...{
              caption: T('주말'),
              value: weekend_bld_sugr_mbti,
            }}
          />
        </HBox>
      </Segment>
    </div>
  );
}

